import React, { useCallback, useEffect, useState } from "react";
import TurnrSnackbar from "./TurnrSnackbar.jsx";
import styles from "./TurnrSnackbarsHandler.module.scss";

const DELETE_ELEMENT_TIMEOUT = 300;
const OPEN_TIME = 5000;

function TurnrSnackbarHandler(props) {
    const { snackbarData, removeSnackbarData } = props;
    const { Component, componentProps, onClose, id } = snackbarData;
    const [open, setOpen] = useState(true);

    const onCloseWrapper = useCallback(() => {
        setOpen(false);
        onClose && onClose();
    }, [setOpen, onClose]);

    useEffect(() => {
        if (open) {
            const timeoutId = setTimeout(function () {
                onCloseWrapper();
            }, snackbarData?.openTime || OPEN_TIME);
            return () => {
                clearTimeout(timeoutId);
            };
        }
    }, [open, onCloseWrapper]);

    useEffect(() => {
        if (!open) {
            const timeoutId = setTimeout(() => {
                removeSnackbarData({ id });
            }, DELETE_ELEMENT_TIMEOUT);

            return () => {
                clearTimeout(timeoutId);
            };
        }
    }, [open, removeSnackbarData]);

    return (
        <TurnrSnackbar open={open} onClose={onCloseWrapper}>
            <Component {...componentProps} onClose={onCloseWrapper} />
        </TurnrSnackbar>
    );
}

export function TurnrSnackbarsHandler(props) {
    const { snackbarsData, removeSnackbarData } = props;

    return (
        <div className={styles["snackbars-container"]}>
            {snackbarsData.map((snackbarData) => {
                return <TurnrSnackbarHandler key={snackbarData.id} snackbarData={snackbarData} removeSnackbarData={removeSnackbarData} />;
            })}
        </div>
    );
}
